import { CreditCardPaymentDto } from '../invoice-builder/invoice-payment/credit-card-payment/dto/credit-card-payment.dto';
import { PayableInvoiceDto } from './payable-invoice.dto';
export interface InvoiceWithPaymentDto {
  Invoice: PayableInvoiceDto;
  CreditCardPayment: CreditCardPaymentDto;
}

export function initializedInvoiceWithPaymentDto() {
  const today = new Date();
  return {
    Invoice: {
      DateCreated: today,
      DateChanged: today,
      InvoiceDate: today,
      DateDue: today,
      PaymentHeader: {},
      InvoiceLineItems: [],
    },
    CreditCardPayment: {
      CreditCardContactInfo: {},
    },
  } as InvoiceWithPaymentDto;
}
